__turbopack_context__.v({
  "container": "f0VnUq_container",
  "content": "f0VnUq_content",
});
